import ProgressSpinnerPR from "./ProgressSpinnerPR";

export default ProgressSpinnerPR;
